/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Chart_HeadingInputs */

const vi_my_grower_report_chart_heading = /** @type {(inputs: My_Grower_Report_Chart_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biểu đồ`)
};

/**

* @param {My_Grower_Report_Chart_HeadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_chart_heading = /** @type {((inputs?: My_Grower_Report_Chart_HeadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Chart_HeadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_chart_heading(inputs)
});